import { chatbotApi } from "..";
import { AxiosResponse } from "axios";

interface ConversationRequest {
  email: string;
}

interface ConversationResponse {
  id: string;
  message: string;
}

export const createConversation = async (
  data: ConversationRequest
): Promise<ConversationResponse> => {
  const response: AxiosResponse<ConversationResponse> = await chatbotApi.post(
    `/conversations`,
    data,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  return response.data;
};
